export const QUIZ_DIAGNOSTICS_OVERLAY_Z_INDEX = 9999999999
